import { ReactElement, useCallback } from 'react';
import { createFetchContext } from '../../../components/contexts/FetchContextFactory';
import { getTeacherSchedule as getBase } from '../api';
import { TeacherScheduleList as Base } from '../types/TeacherSchedule';

interface BaseLoaderProps {
  children: ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  undefined,
  Base
>();

export function useTeacherScheduleLoader() {
  const context = useFetch();
  return {
    data: context.data,
    loading: context.loading,
    error: context.error,
  };
}

export const TeacherScheduleLoaderConsumer = FetchConsumer;

export function TeacherScheduleLoader({ children }: BaseLoaderProps) {
  const request = useCallback(() => {
    return getBase();
  }, []);

  return (
    <FetchProvider
      request={request}
      defaultQuery={undefined}
      fetchImmediately
      children={children}
    />
  );
}
